const getOrigin = () => {
  let string = 'consumer';
  if (window.location.origin.includes('demo')) string = 'logindemo';
  else if (window.location.origin.includes('uat')) string = 'uat';
  return `${string}.vensa.com`;
};

export { getOrigin };
